const guiColors = {
    'motion-primary': '#00BAAD',
    'motion-primary-transparent': '#00BAADe6',
    'motion-tertiary': '#009388',

    'looks-secondary': '#00BAAD',
    'looks-transparent': '#00BAAD59',
    'looks-light-transparent': '#00BAAD26',
    'looks-secondary-dark': '#009388',

    'extensions-primary': '#009388',
    'extensions-tertiary': '#006C64',
    'extensions-transparent': '#00938859',
    'extensions-light': '#00BAAD',

    'drop-highlight': '#00BAAD'
};

const blockColors = {
    checkboxActiveBackground: '#00BAAD',
    checkboxActiveBorder: '#009388'
};

export {
    guiColors,
    blockColors
};